const organisation = (state) => state.organisation

export default {
  organisation
}
